export default __webpack_public_path__ + "static/media/send.bb6632e6.svg";